import React from "react";
import { useNavigate } from "react-router-dom";

import errorImage from "assets/images/errorImage.png"; 
import { PrimaryButton } from "widgets";

import styles from "./ErrorFallback.module.scss";

const ErrorFallback = ({ message }) => {
  const navigate = useNavigate();
  return (
    <div className={styles.errorContainer}>
      <div className={styles.errorCard}>
        <img src={errorImage} alt="Error" className={styles.errorImage} />
        <div className={styles.errorText}>{message || "Something went wrong"}</div>
        <PrimaryButton
          className={styles.retryButton}
          onClick={()=>navigate("/homePage")}
        >
          Go Back to Home
        </PrimaryButton>
      </div>
    </div>
  );
};

export default ErrorFallback;
